export interface BillTypeOption {
  id: string
  label: string
  icon: string
  description?: string
  order?: number
  serviceFee?: number
}

/** Same shape as backend bill category (used in Settings and Bill Payments). */
export type BillCategory = BillTypeOption

export const BILL_TYPES: BillTypeOption[] = [
  { id: 'mobile_reload', label: 'Mobile Reload', icon: '📱', description: 'Prepaid top-up & reloads', serviceFee: 20 },
  { id: 'internet', label: 'Internet Bill', icon: '🌐', description: 'Broadband & ISP bills', serviceFee: 30 },
  { id: 'water', label: 'Water Bill', icon: '💧', description: 'Water board payments', serviceFee: 30 },
  { id: 'electric', label: 'Electric Bill', icon: '⚡', description: 'Electricity payments', serviceFee: 30 },
  { id: 'gas', label: 'Gas Bill', icon: '🔥', description: 'Gas utility bills', serviceFee: 30 },
  { id: 'insurance', label: 'Insurance', icon: '🛡️', description: 'Premium payments', serviceFee: 50 },
  { id: 'other', label: 'Other', icon: '📄', description: 'Other bill payments', serviceFee: 0 },
]

export const PAYMENT_METHODS_BILL = [
  { id: 'cash', label: 'Cash', icon: '💵' },
  { id: 'card', label: 'Card', icon: '💳' },
  { id: 'digital_wallet', label: 'Digital Wallet', icon: '📱' },
  { id: 'bank_transfer', label: 'Bank Transfer', icon: '🏦' },
] as const
